export type FormattedCellValue = string | { display: string; url: string };

export function formattedCellValueToString(value: FormattedCellValue): string {
  if (typeof value === 'string') return value;
  return value.display ? `${value.display}\n${value.url}` : value.url;
}
